import { roles } from "@/data/roadmap";
import { ROADMAP } from "@/constants/testIds/roadmap";
import { SectionLabel } from "./ExecSummary";

export default function Roles() {
  return (
    <section
      id="roles"
      data-testid={ROADMAP.rolesSection}
      className="py-20 lg:py-28 border-b border-[#DEE2E6] bg-[#F8F9FA]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionLabel n="08" label="User Roles & RBAC" />
        <div className="grid lg:grid-cols-12 gap-6 mt-3 items-end">
          <h2 className="lg:col-span-7 font-heading text-3xl md:text-4xl lg:text-5xl tracking-tighter font-bold">
            Right access. Right people. Right time.
          </h2>
          <p className="lg:col-span-5 text-[#495057] leading-relaxed">
            Role-based access control with quarterly reviews and auto-deactivation on HR exit —
            wired straight into the controls catalogue.
          </p>
        </div>

        <div className="mt-14 border border-[#0A0A0A] bg-white overflow-hidden">
          <div className="grid grid-cols-[280px_1fr] gap-0 px-6 py-3.5 bg-[#0A0A0A] text-white text-xs uppercase tracking-[0.2em]">
            <div>Role</div>
            <div>Access scope</div>
          </div>
          {roles.map((r, i) => (
            <div
              key={r.role}
              data-testid={`role-row-${i}`}
              className={`grid grid-cols-1 md:grid-cols-[280px_1fr] gap-2 md:gap-0 px-6 py-4 ${
                i !== roles.length - 1 ? "border-b border-[#DEE2E6]" : ""
              } hover:bg-[#F8F9FA] transition-colors`}
            >
              <div className="font-medium text-[#0A0A0A]">{r.role}</div>
              <div className="text-sm text-[#495057] leading-relaxed">{r.access}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
